// Plain-English messages for the setup-fee decisions (CWA-196). The codes come
// from contracts/admin-setup-fee.md in account-management's
// specs/014-setup-fee-invoice and arrive as `error_code` on the service's
// ErrorResponse ({ timestamp, message, status, path, error_code, error_args }).
// `message` is engineering text and is never shown.

const MESSAGES: Record<string, string> = {
  SETUP_FEE_CUSTOMER_NOT_FOUND:
    "Customer not set up in billing — contact engineering.",
  SETUP_FEE_BILLING_UNAVAILABLE:
    "Billing is temporarily unavailable — try again; no duplicate invoice will be created.",
  SETUP_FEE_ALREADY_DECIDED:
    "The setup fee has already been invoiced or waived. Reload the page to see the decision.",
  SETUP_FEE_INVOICE_IN_PROGRESS:
    "An invoice for this setup fee is being created right now. Wait a moment, then reload the page.",
  SETUP_FEE_NOT_DUE:
    "The setup fee is not due: the prospect has not been promoted to a customer, or has resigned.",
  WAIVER_REASON_REQUIRED: "Enter a reason for waiving the setup fee.",
  WAIVER_REASON_TOO_LONG: "The reason is too long. Keep it to 1000 characters.",
};

export const setupFeeErrorMessage = (err: any): string => {
  const code = err?.response?.data?.error_code;
  if (typeof code === "string" && MESSAGES[code]) return MESSAGES[code];
  const status = err?.response?.status;
  // A gateway timeout arrives without a body, and retrying it is just as safe.
  if (status === 503 || status === 504) {
    return MESSAGES.SETUP_FEE_BILLING_UNAVAILABLE;
  }
  if (status === 404) {
    return "This prospect could not be found. Reload the page and try again.";
  }
  return "The setup fee could not be updated. Please try again.";
};
